import React from 'react';
import { SvgType } from '../svgType';

export default ({ color, className }: SvgType) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="31.5"
    height="31.5"
    viewBox="0 0 31.5 31.5"
  >
    <g transform="translate(1463.059 -4099)">
      <path
        d="M180.691.75a15,15,0,1,1-15,15,15,15,0,0,1,15-15"
        transform="translate(-1628 4099)"
        fill="#fff"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M180.691.75v15l-12.98-7.494A14.991,14.991,0,1,0,180.691.75"
        transform="translate(-1628 4099)"
        fill={color}
      />
    </g>
  </svg>
);
